module.exports = __webpack_public_path__ + "img/2.a1dc27ad.jpg";